import html2canvas from 'html2canvas';

export async function captureScreenshot(elementIds = [], excludeIds = []) {
    const canvases = [];
    const backgroundColor = getComputedStyle(document.body).getPropertyValue('--color-background').trim();
    const margin = 20; // margin value

    // Temporarily hide elements that should be excluded
    const excludedElements = excludeIds.map(id => document.getElementById(id)).filter(el => el);
    excludedElements.forEach(el => {
        el.style.visibility = 'hidden';
    });

    // Capture each element separately
    for (const id of elementIds) {
        const element = document.getElementById(id);
        if (element) {
            const canvas = await html2canvas(element, { backgroundColor: backgroundColor });
            canvases.push(canvas);
        }
    }

    // Restore the visibility of the excluded elements
    excludedElements.forEach(el => {
        el.style.visibility = 'visible';
    });

    // Calculate the total height and width for the final canvas with margins
    const totalHeight = canvases.reduce((sum, canvas) => sum + canvas.height, 0) + (margin * (canvases.length + 1));
    const maxWidth = Math.max(...canvases.map(canvas => canvas.width)) + 2 * margin;

    // Create a new canvas to fit all canvases
    const finalCanvas = document.createElement('canvas');
    finalCanvas.width = maxWidth;
    finalCanvas.height = totalHeight;
    const context = finalCanvas.getContext('2d');

    // Fill the entire canvas with the background color
    context.fillStyle = backgroundColor;
    context.fillRect(0, 0, maxWidth, totalHeight);

    // Draw each canvas image to the final canvas with margins
    let offsetY = margin;
    for (const canvas of canvases) {
        context.drawImage(canvas, margin, offsetY); // Added margin to x and y positions
        offsetY += canvas.height + margin;
    }

    // Download the final stitched image
    const link = document.createElement('a');
    link.href = finalCanvas.toDataURL('image/png');
    link.download = 'screenshot.png';
    link.click();
}
